(function () {
  'use strict';

  function init(root) {
    if (root.__csInit) return;
    root.__csInit = true;

    var toggle = root.querySelector('[data-country-toggle]');
    var panel = root.querySelector('[data-country-panel]');
    if (!toggle || !panel) return;

    function open() {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', onDocClick, true);
      document.addEventListener('keydown', onKeyDown, true);
    }

    function close(returnFocus) {
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick, true);
      document.removeEventListener('keydown', onKeyDown, true);
      if (returnFocus) toggle.focus();
    }

    function onDocClick(e) {
      if (!root.contains(e.target)) close(false);
    }

    function onKeyDown(e) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        close(true);
      }
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (toggle.getAttribute('aria-expanded') === 'true') close(false);
      else open();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-country-selector]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
